// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
  Box,
  Button,
  Container as MuiContainer,
  GlobalStyles,
  lighten,
  Paper,
  Stack,
  styled,
  Typography
} from '@mui/material';
import { useMemo } from 'react';
import Countdown from 'react-countdown';

import { usePhase } from '../../hooks/usePhase';
import IconSuccess from '../verify/icon_success.svg';
import Verify from './Verify';

const Wrapper = styled(Box)({
  paddingTop: 128,
  paddingBottom: 128
});

const Container = styled(MuiContainer)({
  margin: '0 auto'
});

const Content = styled(Paper)({
  marginTop: 24,
  padding: '20px 44px',
  background: 'rgba(255,255,255,0.8)',
  boxShadow: '0px 3px 30px rgba(27,145,150,0.3)',
  borderRadius: 8
});

function Champion() {
  const phases = usePhase();
  const prizeList = useMemo(
    () => 'ggjvzd#3620 sdfh5505#0520 Adamc#5707 gxllb#0231 3198sqy#1434'.split(' '),
    []
  );
  const end = useMemo(() => Date.now() > 1671580799000, []);

  return (
    <Wrapper>
      <GlobalStyles
        styles={{
          body: {
            background: 'url(png_bac.svg) no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }
        }}
      />
      <Container>
        <Typography fontWeight={500} mb={2.5} textAlign="center" variant="h2">
          Argentina is the champion! Are you the winner?
        </Typography>
        {/* <Typography textAlign="center">
          5 raffle winners for $1000 and 5 NFT whitelist will be announced on Dec. 21
        </Typography> */}
        <Box
          component={Content}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box>
            <Typography variant="h5">
              5 raffle winners for $1000 and 5 NFT whitelist will be announced on Dec. 21
            </Typography>
            <Button
              endIcon={<ArrowRightAltIcon />}
              onClick={() =>
                window.open(
                  'https://zcloaknetwork.medium.com/phase-ii-worlds-first-zk-guessing-for-the-world-cup-games-zero-knowledge-proof-for-semi-finals-680d66404639'
                )
              }
              sx={{
                marginTop: 2,
                background: '#000000',
                border: '1px solid #1B9196',
                boxShadow: '0px 3px 20px rgba(27,145,150,0.71)',
                borderRadius: '9px',
                color: '#fff',
                ':hover': {
                  background: '#000000'
                }
              }}
              variant="contained"
            >
              Phase Guide
            </Button>
          </Box>
          <Box>
            <Typography mb={2}>End Countdown: </Typography>
            <Countdown
              date={1671580799000}
              renderer={({ completed, days, hours, minutes, seconds }) => {
                if (completed) {
                  return 'End';
                } else {
                  return (
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{
                        '>div': {
                          width: '48px',
                          height: '48px',
                          background: '#333333',
                          border: '1px solid #707070',
                          borderRadius: '4px',
                          fontSize: '34px',
                          lineHeight: '48px',
                          textAlign: 'center',
                          fontWeight: 700,
                          color: '#E2B436'
                        }
                      }}
                    >
                      <Box>{days}D</Box>
                      <Box>{String(hours).length === 1 ? `0${hours}` : hours}</Box>
                      <Box>{String(minutes).length === 1 ? `0${minutes}` : minutes}</Box>
                      <Box>{String(seconds).length === 1 ? `0${seconds}` : seconds}</Box>
                    </Stack>
                  );
                }
              }}
            />
          </Box>
        </Box>
        {end ? (
          <Content>
            <Typography mb={4} variant="h6">
              Congratulations to the following 5 lucky draw winners who will share our $1000 prize
              pool and 5 Player Pass NFT Whitelist from Macondo! Please refer to the Phase IV Guide
              after Dec.20 for details on how to claim your prizes.
              <br />
              <ul
                style={{
                  display: 'flex',
                  width: '100%',
                  flexFlow: 'row wrap',
                  alignContent: 'flex-start'
                }}
              >
                {prizeList.map((name, idx) => {
                  return (
                    <li key={idx} style={{ minWidth: '220px' }}>
                      {name}
                    </li>
                  );
                })}
              </ul>
            </Typography>
            <Box textAlign="center">
              <Button disabled size="large" variant="contained">
                Phase III is over
              </Button>
            </Box>
          </Content>
        ) : phases?.[2] ? (
          <Content
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.8,
              color: 'rgba(0, 0, 0, 1)!important',
              height: 276,
              marginTop: 3,
              background: `linear-gradient(330deg, ${lighten('#FFEDB7', 0.6)} 0%, ${lighten(
                '#FFA6CB',
                0.6
              )} 100%)`,
              '>img': {
                marginBottom: 3,
                opacity: 1
              }
            }}
          >
            <img src={IconSuccess} />
            Congratulations！The team you guessed is the champion!
          </Content>
        ) : (
          <Content>
            <Typography mb={4} variant="h6">
              Argentina won the championship. Now you can reveal to us whether your guess is
              correct. For participants who guessed wrong, don’t worry, no one knows what your guess
              is and you can claim 6 OAT/POAP in Phase IV.
            </Typography>
            <Box textAlign="center">
              <Verify phases={phases} />
            </Box>
          </Content>
        )}
      </Container>
    </Wrapper>
  );
}

export default Champion;
